document.getElementById('changeContent').addEventListener('click', () => {
  const elements = document.querySelectorAll('.gs_jump');

  elements.forEach(element => {
    const paragraphs = element.querySelectorAll('p');

    paragraphs.forEach((p, index) => {
      p.textContent = `New content ${index + 1}`;
    });
  });
});